import { defineComponent, type PropType } from "vue";
import {
    PublicFooter,
    PublicNavbar,
    usePublicLocalizedPath,
} from "./PublicShell.js";
import { useLocale } from "../../locales/i18n.js";

type ErrorAction = {
    href?: string;
    icon: string;
    label: string;
    to?: string;
    variant: "primary" | "secondary";
};

export default defineComponent({
    props: {
        actions: {
            type        : Array as PropType<ErrorAction[]>,
            required    : true,
        },
        code: {
            type        : String,
            required    : true,
        },
        description: {
            type        : String,
            required    : true,
        },
        icon: {
            type        : String,
            required    : true,
        },
        kicker: {
            type        : String,
            required    : true,
        },
        title: {
            type        : String,
            required    : true,
        },
    },

    setup(props) {
        const { i18n } = useLocale();
        const publicPath = usePublicLocalizedPath();

        function renderAction(action: ErrorAction) {
            const className = action.variant === "primary"
                ? "landing-button landing-button-dark"
                : "public-error-secondary";

            const content = (
                <>
                    <span>{action.label}</span>
                    <i class="material-symbols-outlined">{action.icon}</i>
                </>
            );

            if (action.href)
                return (
                    <a class={className} href={action.href}>
                        {content}
                    </a>
                );

            return (
                <router-link class={className} to={publicPath(action.to || "/")}>
                    {content}
                </router-link>
            );
        }

        return () => (
            <div class="landing-page public-error-page">
                <PublicNavbar />

                <div class="public-error-layout">
                    <div class="public-error-copy">
                        <span class="landing-kicker">{props.kicker}</span>

                        <h1>{props.title}</h1>
                        <p>{props.description}</p>

                        <div class="public-error-actions">
                            {props.actions.map(renderAction)}
                        </div>
                    </div>

                    <div class="public-error-card" aria-label={i18n("public.error.aria", props.code)}>
                        <div class="public-error-code">{props.code}</div>

                        <div class="public-error-icon">
                            <i class="material-symbols-outlined">{props.icon}</i>
                        </div>

                        <div>
                            <span>LOGSCORD</span>
                            <strong>{i18n("public.error.card_slogan")}</strong>
                        </div>
                    </div>
                </div>

                <PublicFooter />
            </div>
        );
    },
});
